import { assert_array_typeof_number, assert_equal, assert_false, assert_instanceof, assert_true, assert_type_enum } from '@shared/asserts/utils_asserts';
import { DTO__number_range } from '@shared/dto/generation/settings/DTO__number_range';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { number_average } from '@shared/utils/utils_number';
import { DTO_GRAPH__instance } from '../../../_graph/DTO_GRAPH__instance';
import { ENUM__field_connectable_type } from '../../_base/_methods/ENUM__field_connectable_type';
import { FIELD__base } from '../../_base/FIELD__base';
import { DECORATOR__class_serialization_tested } from '../_base/DECORATOR__class_serialization_tested';
import { DECORATOR__class_serialization_tested_for_hash } from '../_base/DECORATOR__class_serialization_tested_for_hash';
import { DECORATOR__field_not_linked } from '../_base/DECORATOR__field_not_linked';
import { ENUM__list_mode } from './ENUM__list_mode';

//todo:validate value with range
//todo: validate amount of items
//todo:validate values allowed

//todo: copy validation from primitive number

@DECORATOR__class_serialization_tested
@DECORATOR__class_serialization_tested_for_hash
export class FIELD_PRIMITIVE__list_float_dynamic extends FIELD__base {
  /*
   * STATIC FIELDS
   */

  static _class_name_static = ENUM__dto_class_name.GRAPH_FIELD_LIST_FLOAT_DYNAMIC;

  /*
   * STATIC METHODS
   */

  static get_meta_params_default() {
    let out = super.get_meta_params_default();

    out.grid2d__can_be_dimension = true;

    return out;
  }

  /*
   * FIELDS
   */

  mode!: ENUM__list_mode;

  value: number[];
  value_range!: DTO__number_range;
  values_allowed!: DTO__number_range;

  slider_step!: number;
  slider_step_values: number[];

  /*
   * FIELDS GRAPH
   */

  // todo: implement as FIELD connectable
  amount_items!: number;
  /*
   * PROPERTIES
   */
  field_connectable__type() {
    return ENUM__field_connectable_type.LIST_FLOAT_DYNAMIC;
  }

  field_connectable__value(graph: DTO_GRAPH__instance): string {
    return `${this.value.length} items`;
  }

  /*
   * VALUE
   */

  get_value(): number[] {
    assert_array_typeof_number(this.value);

    return this.value;
  }

  /*
   * VALUE RANGE
   */
  get_value_range() {
    assert_instanceof(this.value_range, DTO__number_range);

    return this.value_range;
  }

  get average(): number {
    let out = number_average(this.get_value());

    return out;
  }

  get grid2d_dimension_values() {
    assert_equal(this.mode, ENUM__list_mode.ONE_ITEM);
    assert_true(this.meta.grid2d__is_dimension);
    assert_false(this.value_range.is_stub());

    return this.get_value_range().to_array(this.slider_step);
  }

  /*
   * EVENTS
   */

  /*
   * METHODS
   */

  constructor() {
    super();

    this.amount_items = 1;
    this.value = [];
    this.value_range = DTO__number_range.CREATE_STUB();
    this.values_allowed = DTO__number_range.CREATE_STUB();
    this.slider_step_values = [];
  }

  /*
   *
   */

  @DECORATOR__field_not_linked()
  store__serialization_keys_list_white_for_hash(): string[] {
    let out: (keyof this)[] = [];

    out.push('amount_items');
    out.push('value');

    return out as string[];
  }

  /*
   *
   */

  assert_standard_fields(): void {
    super.assert_standard_fields();

    assert_array_typeof_number(this.value);

    assert_type_enum(this.mode, ENUM__list_mode);
  }
}
